/* tslint:disable */
/* eslint-disable */
/**
 * Melco Identity APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    IdentityMelcoModelsCustomWarning,
    IdentityMelcoModelsCustomWarningFromJSON,
    IdentityMelcoModelsCustomWarningFromJSONTyped,
    IdentityMelcoModelsCustomWarningToJSON,
    IdentityMelcoModelsLocaleGroup,
    IdentityMelcoModelsLocaleGroupFromJSON,
    IdentityMelcoModelsLocaleGroupFromJSONTyped,
    IdentityMelcoModelsLocaleGroupToJSON,
} from './';

/**
 * 
 * @export
 * @interface IdentityMelcoModelsGenericList1MelcoModelsLocaleGroup
 */
export interface IdentityMelcoModelsGenericList1MelcoModelsLocaleGroup {
    /**
     * 
     * @type {Array<IdentityMelcoModelsLocaleGroup>}
     * @memberof IdentityMelcoModelsGenericList1MelcoModelsLocaleGroup
     */
    list: Array<IdentityMelcoModelsLocaleGroup>;
    /**
     * 
     * @type {Array<IdentityMelcoModelsCustomWarning>}
     * @memberof IdentityMelcoModelsGenericList1MelcoModelsLocaleGroup
     */
    warning_list?: Array<IdentityMelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {number}
     * @memberof IdentityMelcoModelsGenericList1MelcoModelsLocaleGroup
     */
    total: number;
}

export function IdentityMelcoModelsGenericList1MelcoModelsLocaleGroupFromJSON(json: any): IdentityMelcoModelsGenericList1MelcoModelsLocaleGroup {
    return IdentityMelcoModelsGenericList1MelcoModelsLocaleGroupFromJSONTyped(json, false);
}

export function IdentityMelcoModelsGenericList1MelcoModelsLocaleGroupFromJSONTyped(json: any, ignoreDiscriminator: boolean): IdentityMelcoModelsGenericList1MelcoModelsLocaleGroup {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(IdentityMelcoModelsLocaleGroupFromJSON)),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(IdentityMelcoModelsCustomWarningFromJSON)),
        'total': json['total'],
    };
}

export function IdentityMelcoModelsGenericList1MelcoModelsLocaleGroupToJSON(value?: IdentityMelcoModelsGenericList1MelcoModelsLocaleGroup | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(IdentityMelcoModelsLocaleGroupToJSON)),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(IdentityMelcoModelsCustomWarningToJSON)),
        'total': value.total,
    };
}


